import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/Auth/LoginForm';
import RegistrationForm from '../components/Auth/RegistrationForm';
import VerificationForm from '../components/Auth/VerificationForm';
import ForgotPasswordForm from '../components/Auth/ForgotPasswordForm';
import { useTranslation } from 'react-i18next';
import { switchLanguage } from '../i18n';
// ❌ احذف هذا السطر
// import { getEventContext } from '../context/eventContext';
import '../styles/pages/AuthPage.css';
import logoFooter from '../assets/CiteScholar_logo_light.png';

const AuthPage = () => {
  const { t, i18n } = useTranslation('auth');
  const [, setCurrentLanguage] = useState(i18n.language || 'en');
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [verificationData, setVerificationData] = useState(null);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const navigate = useNavigate();

  // ❌ احذف هذا السطرين
  // const eventCtx = getEventContext();

  // ✅ استخدم logo افتراضي مباشرة
  const eventLogo = 'https://emiratesscholar.com/system/images/logo-esrc.png';

  // ✅ استخدم title من الترجمة
  const pageTitle = t('title', 'Emirates Scholar Center for Research and Studies');

  console.log('📋 [AuthPage] eventLogo:', eventLogo);
  console.log('📋 [AuthPage] pageTitle:', pageTitle);

  useEffect(() => {
    const authToken = localStorage.getItem('auth_token');
    const isVerifyPath = window.location.pathname === '/verify-email';

    if (authToken) {
      const storedResponse = localStorage.getItem('login_response_full');
      let isVerified = true;
      if (storedResponse) {
        try {
          const data = JSON.parse(storedResponse);
          const isUnverified = data.userVerified === false ||
            data.userVerified === 'false' ||
            data.userVerified === 0 ||
            data.success?.userVerified === false ||
            data.Profile?.userVerified === false ||
            data.UserDetails?.userVerified === false ||
            data.Profile?.usr_det?.userVerified === false ||
            data.user_verified === false ||
            data.success?.user_verified === false ||
            data.Profile?.user_verified === false;
          if (isUnverified) {
            isVerified = false;
            setVerificationData({
              token: authToken,
              email: data.Profile?.email || data.UserDetails?.email || data.success?.email || localStorage.getItem('unverified_email') || '',
              response: data,
              from: 'stored'
            });
          }
        } catch (e) {
          console.error('Error parsing stored auth response:', e);
        }
      }

      if (isVerified) {
        navigate('/dashboard', { replace: true });
      } else {
        setIsCheckingAuth(false);
      }
    } else {
      if (isVerifyPath) {
        navigate('/', { replace: true });
      } else {
        setIsCheckingAuth(false);
      }
    }
  }, [navigate]);

  useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLanguage(i18n.language);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  const handleToggleLanguage = (lang) => {
    switchLanguage(lang);
  };

  if (isCheckingAuth) {
    return (
      <div className="auth-loading">
        <div className="auth-spinner"></div>
        <p>{t('checking_auth', 'Checking authentication...')}</p>
      </div>
    );
  }

  const isVerifyRoute = window.location.pathname === '/verify-email';

  return (
    <div>
      <div className="auth-container">
        {/* Top Bar */}
        <div className="top-bar">
          <div onClick={() => window.open('https://www.emiratesscholar.com/', 'blank')} className="official-website">
            <span className="pipe"></span> {t('official_website', 'OFFICIAL WEBSITE')}
          </div>
          <div className="language-flags">
            <button onClick={() => handleToggleLanguage('en')} title="English">
              <img src="https://flagicons.lipis.dev/flags/4x3/gb.svg" alt="UK Flag" />
            </button>
            <button onClick={() => handleToggleLanguage('ar')} title="العربية">
              <img src="https://flagicons.lipis.dev/flags/4x3/ae.svg" alt="UAE Flag" />
            </button>
          </div>
        </div>
        <hr className="top-divider" />

        {/* Logo */}
        <div className="logo-placeholder">
          <img src={eventLogo} alt={pageTitle} className="logo-img" />
        </div>
        <hr className="top-divider" />

        <div>
          <nav className="breadcrumb">
            <a href="/">{t('home', 'Home')}</a>
            <span className="separator"> / </span>
            <span className="current">
              {verificationData || isVerifyRoute
                ? t('verify_account', 'Verify Account')
                : showForgotPassword
                  ? t('forgot_password_title', 'Forgot Password')
                  : t('login', 'Login')}
            </span>
          </nav>
        </div>

        {/* Title من الترجمة */}
        <h1 className="main-title">
          {verificationData || isVerifyRoute
            ? t('verify_account', 'Verify Account')
            : showForgotPassword
              ? t('forgot_password_title', 'Forgot Password')
              : pageTitle}
        </h1>

        {/* Forms Container */}
        {verificationData || isVerifyRoute ? (
          <div style={{ marginTop: '20px' }}>
            <VerificationForm
              t={t}
              verificationData={verificationData}
              onBack={() => {
                localStorage.removeItem('auth_token');
                localStorage.removeItem('login_response_full');
                localStorage.removeItem('unverified_email');
                setVerificationData(null);
                navigate('/', { replace: true });
              }}
            />
          </div>
        ) : showForgotPassword ? (
          <div style={{ marginTop: '20px' }}>
            <ForgotPasswordForm t={t} onBack={() => setShowForgotPassword(false)} />
          </div>
        ) : (
          <div className="auth-forms">
            <LoginForm
              t={t}
              onVerificationRequired={setVerificationData}
              onForgotPassword={() => setShowForgotPassword(true)}
            />
            <RegistrationForm
              t={t}
              onVerificationRequired={setVerificationData}
              onForgotPassword={() => setShowForgotPassword(true)}
            />
          </div>
        )}
      </div>

      {/* Footer */}
      <footer
        className="page-footer"
        style={{
          backgroundColor: "#000",
          color: "#fff",
        }}
      >
        <div className="footer-content">
          <div className="footer-logo">
            <div className="cite-logo-text">
              <img
                src={logoFooter}
                alt="logo"
                onClick={() => window.open("https://emiratesscholar.com/", "_blank")}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <div className="footer-copyright">
            {t(
              "powered_by",
              "Powered by Cite Scholar™. Emirates Scholar Research Center. All rights reserved ©2026."
            )}          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthPage;